import clsx from 'clsx'
import * as React from 'react'

import type { FormFieldWrapperDummyProps } from './type'

import { layoutClassName } from '../const'

export const FormFieldWrapperDummy = ({
  children,
}: FormFieldWrapperDummyProps) => {
  return (
    <div>
      <div
        className={clsx('tw-block tw-text-sm tw-font-medium tw-text-gray-700')}
      >
        <span className={clsx(layoutClassName.label)} />
        <div>{children}</div>
      </div>
    </div>
  )
}
